import { UseData } from "@/hooks/useData";
import useQueries from "@/hooks/useQueries";
import { buildQuery } from "@/shared/utils/buildQuery";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { Entity, Item } from "./types";

const fetchBusinesses = async () => {
    let allBusinesses: any[] = [];
    let hasMore = true;
    let currentPage = 1;
    while (hasMore) {
        const response = await axios.get(`https://w-ord.ntelgnt.com/proxy.php?endpoint=businesses?limit=25&page=${currentPage}`, { params: { api: 'optimus' } });
        const dataResponse = response?.data?.[0];
        if (dataResponse?.data) {
            allBusinesses = [...allBusinesses, ...dataResponse.data];
        }
        if (dataResponse?.pagination?.has_more_pages) {
            currentPage++;
        } else {
            hasMore = false;
        }
    }
    return [{ data: allBusinesses }];
};

const fetchBusinessAddresses = async () => {
    let allBusinessesAddresses: any[] = [];
    let hasMore = true;
    let currentPage = 1;
    while (hasMore) {
        const response = await axios.get(`https://w-ord.ntelgnt.com/proxy.php?endpoint=business-addresses?limit=25&page=${currentPage}`, { params: { api: 'optimus' } });
        const dataResponse = response?.data?.[0];
        if (dataResponse?.data) {
            allBusinessesAddresses = [...allBusinessesAddresses, ...dataResponse.data];
        }
        if (dataResponse?.pagination?.has_more_pages) {
            currentPage++;
        } else {
            hasMore = false;
        }
    }
    return [{ data: allBusinessesAddresses }];
};

const useEntities = () => {
    const queries = useQueries();

    const itemsQuery = queries ? buildQuery(queries.itemsQuery) : '';
    const addressesColorsProjectsQuery = queries
        ? buildQuery(queries.addressesColorsProjectsQuery)
        : '';

    const { data: fetchedItems, isLoading: itemsLoading } = UseData({
        q: itemsQuery,
        // apiUrl: API_URL,
        // dependency: [itemsQuery],
    });

    const { data: fetchedEntities, isLoading: entitiesLoading } = UseData({
        q: addressesColorsProjectsQuery,
        // apiUrl: API_URL,
        // dependency: [addressesColorsProjectsQuery],

    });


    const { data: businesses = [], isLoading: businessesLoading } = useQuery({
        queryKey: ['businesses'],
        queryFn: fetchBusinesses,
        staleTime: 0,
        refetchOnMount: true,
    });
    const { data: businessAddresses, isLoading: addressesLoading } = useQuery({
        queryKey: ['business-addresses'],
        queryFn: fetchBusinessAddresses,
        staleTime: 0,
        refetchOnMount: true,
    });

    const items: Item[] = fetchedItems?.data?.result || [];
    const entities: Entity[] = fetchedEntities?.data?.result || [];

    const colors = entities.filter(e => e.data_type?.toLowerCase() === 'color');
    const projects = entities.filter(e => e.data_type?.toLowerCase() === 'project');
    const places = entities.filter(e => e.data_type?.toLowerCase() === 'place');
    const users = entities.filter(e => e.data_type?.toLowerCase() === 'user');

    const projectsWithBusiness = projects?.map(project => {
        const matchedBusiness = businesses?.[0]?.data?.find(
            (b: any) => b['name']?.trim() === project?.type_name?.trim()
        );
        const business_id = matchedBusiness?.id ?? project?.type_id;

        const matchedBusinessAddress = businessAddresses?.[0]?.data?.find(
            (ba: any) => ba['business.id'] === business_id
        );
        const business_address_id = matchedBusinessAddress?.id ?? 0;

        return {
            ...project,
            business_id,
            business_address_id,
        };
    });

    return {
        items,
        colors,
        projects,
        projectsWithBusiness,
        places,
        itemsQuery,
        addressesColorsProjectsQuery,
        isLoading: itemsLoading || entitiesLoading || businessesLoading || addressesLoading,
        users
    };
};

export default useEntities;